function barkbootSetupProduct(root){
  const variantData=root.querySelector('[data-variants]');
  if(!variantData) return;

  let variants=[];
  try{variants=JSON.parse(variantData.textContent);}catch(e){return;}

  const selects=[...root.querySelectorAll('[data-option-select]')];
  const hidden=root.querySelector('[data-variant-id]');
  const price=root.querySelector('[data-price]');
  const button=root.querySelector('[data-add]');
  const status=root.querySelector('[data-variant-status]');

  const findVariant=(values)=>variants.find(v=>v.options.length===values.length && v.options.every((value,index)=>value===values[index]));

  function refreshAvailability(){
    if(!selects.length) return;
    const chosen=selects.map(s=>s.value);

    selects.forEach((select,selectIndex)=>{
      [...select.options].forEach(option=>{
        const trial=[...chosen];
        trial[selectIndex]=option.value;
        const match=findVariant(trial);
        option.disabled=!match || !match.available;
      });
    });
  }

  function update(pushUrl=true){
    const chosen=selects.map(s=>s.value);
    const variant=selects.length ? findVariant(chosen) : variants[0];

    refreshAvailability();

    if(!variant){
      if(hidden) hidden.value='';
      if(button){button.disabled=true;button.textContent='Unavailable';}
      if(status) status.textContent='That combination is not available.';
      return;
    }

    if(hidden) hidden.value=variant.id;

    if(price){
      price.textContent=variant.price+' ';
      if(variant.compare){
        const old=document.createElement('s');
        old.textContent=variant.compare;
        price.append(old);
      }
    }

    if(button){
      button.disabled=!variant.available;
      button.textContent=variant.available?'Add to bag':'Sold out';
    }

    if(status) status.textContent=variant.available?'':'This option is currently unavailable.';

    if(pushUrl){
      const url=new URL(location.href);
      url.searchParams.set('variant',variant.id);
      history.replaceState({},'',url);
    }

    if(variant.mediaId){
      const media=document.getElementById('Media-'+variant.mediaId);
      if(media){
        const gallery=media.parentElement;
        if(gallery.firstElementChild!==media) gallery.prepend(media);
      }
    }
  }

  selects.forEach(select=>select.addEventListener('change',()=>update(true)));
  update(false);
}

document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-product-root]').forEach(barkbootSetupProduct);
});

document.addEventListener('keydown',event=>{
  if(event.key==='Escape'){
    document.querySelectorAll('.mobile-menu[open],.subnav[open]').forEach(el=>{
      el.open=false;
      const summary=el.querySelector('summary');
      if(summary) summary.focus();
    });
  }
});
